import React, { useState, useEffect } from "react";
import Headline from "../components/RequirementNew/Headline";
import Table from "../components/RequirementNew/Table";
import Layout from "../layout/Main";
import { http } from "../misc/http";

export default function RequirementNew() {
  const [requirement, setRequirement] = useState([]);

  const handleGetRequirement = async () => {
    let params = {
      method: "GET",
      path: 'requirement/findAll',
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      setRequirement(data.data);
    }
  };

  useEffect(() => {
    handleGetRequirement()
  }, []);

  return <Layout>
    <Headline/>
    <Table requirement={requirement}/>
  </Layout>;
}
